<div class="container-fluid" *ngIf="isLoaded" [@fadeInAnimation]>
  <div class="row">
    <div class="col-xl-1"></div>
    <div class="col-xl-10">
      <div class="card mb-3">
        <div class="card-header">
          <arbetstagare-icon [arbetstagare]="anstallning.arbetstagare" color="#fff" size="lg" class="mr-2"></arbetstagare-icon>{{ anstallning.arbetstagare.personNr12Siffror }} <span [class.redacted]="isConfidential">{{ anstallning.arbetstagare.efternamn }}, {{ anstallning.arbetstagare.fornamn }}</span>
        </div>
        <div class="card-body">
          <p class="h5">Arbetstagarens kontaktuppgifter</p>
          <ul class="list-unstyled">
            <li><span [class.redacted]="isConfidential">{{ anstallning.arbetstagare.fornamn }} {{ anstallning.arbetstagare.efternamn }}{{ anstallning.arbetstagare.careof ? ' &#8453; ' + anstallning.arbetstagare.careof : '' }}</span></li>
            <li><span [class.redacted]="isConfidential">{{ anstallning.arbetstagare.gatuadress }}</span></li>
            <li class="mb-2"><span [class.redacted]="isConfidential">{{ anstallning.arbetstagare.postnummer }} {{ anstallning.arbetstagare.postort | uppercase }}</span></li>
            <li *ngIf="!!anstallning.arbetstagare.telefon"><span [class.redacted]="isConfidential"><b><fa-icon [icon]="['fas', 'phone']" size="sm" class="mr-2"></fa-icon><a [href]="'tel:' + anstallning.arbetstagare.telefon">{{ anstallning.arbetstagare.telefon }}</a></b></span></li>
            <li *ngIf="!!anstallning.arbetstagare.epost"><span [class.redacted]="isConfidential"><b><fa-icon [icon]="['fas', 'at']" size="sm" class="mr-2"></fa-icon><a [href]="'mailto:' + anstallning.arbetstagare.epost">{{ anstallning.arbetstagare.epost | lowercase }}</a></b></span></li>
            <li class="mt-2" *ngIf="!!anstallning.not1 || !!anstallning.not2 || !!anstallning.not3">
              <ul class="list-unstyled ml-3">
                <li class="badge badge-pill badge-notis" *ngIf="!!anstallning.not1">{{ anstallning.not1 }}</li>
                <li class="badge badge-pill badge-notis" *ngIf="!!anstallning.not2">{{ anstallning.not2 }}</li>
                <li class="badge badge-pill badge-notis" *ngIf="!!anstallning.not3">{{ anstallning.not3 }}</li>
              </ul>
            </li>
          </ul>
          <div class="alert alert-light" *ngIf="!!anstallning.kommentar"><pre>{{ anstallning.kommentar }}</pre></div>
          <hr />
          <p class="h5">Arbetstagarens beslut</p>
          <div class="table-responsive" *ngIf="anstallning.lonegarantiBeslut.length">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" [class.order-active]="orderName==='beslutTyp'" (click)="setOrder('beslutTyp', ['beslutTyp.typ'])" style="width: 80px">
                    <div class="d-flex justify-content-between">
                      Typ
                      <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                    </div>
                  </th>
                  <th scope="col" [class.order-active]="orderName==='datum'" (click)="setOrder('datum', ['datum'])" style="width: 120px">
                    <div class="d-flex justify-content-between">
                      Datum
                      <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                    </div>
                  </th>
                  <th scope="col" [class.order-active]="orderName==='period'" (click)="setOrder('period', ['periodFrom', 'periodTom'])">
                    <div class="d-flex justify-content-between">
                      Period
                      <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                    </div>
                  </th>
                  <th scope="col" [class.order-active]="orderName==='lgBelopp'" class="text-right-sm-left" (click)="setOrder('lgBelopp', ['lgBeloppTotal_cache'])">
                    <div class="d-flex justify-content-between">
                      <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="mr-2" [flip]="reverse||'vertical'"></fa-icon>
                      Lönegaranti
                    </div>
                  </th>
                  <th scope="col" [class.order-active]="orderName==='fordranBelopp'" class="text-right-sm-left" (click)="setOrder('fordranBelopp', ['fordranBeloppTotal_cache'])">
                    <div class="d-flex justify-content-between">
                      <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="mr-2" [flip]="reverse||'vertical'"></fa-icon>
                      Fordran
                    </div>
                  </th>
                  <th scope="col" [class.order-active]="orderName==='harFil'" (click)="setOrder('harFil', ['harFil'])" style="width: 140px">
                    <div class="d-flex justify-content-between">
                      Dokument
                      <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                    </div>
                  </th>
                  <th scope="col" class="text-center-sm-left" style="width:160px">Signatur</th>
                  <th scope="col" class="text-center-sm-left" style="width:45px" *ngIf="role==='adv'">Vald</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of anstallning.lonegarantiBeslut | orderBy: order:reverse:'case-insensitive'" [class.active]="c.isSelected">
                  <td data-name="Typ" title="Beslutstyp"><beslut-icon [arendeTyp]="anstallning.arende.arendeTyp" [beslutTyp]="c.beslutTyp"></beslut-icon></td>
                  <td data-name="Datum" title="Beslutsdatum">{{ c.datum | localizeddate:'shortDate' }}</td>
                  <td data-name="Period" title="Period">{{ c.periodFrom | localizeddate:'shortDate' }} &ndash; {{ c.periodTom | localizeddate:'shortDate' }}</td>
                  <td data-name="Lönegaranti" title="Lönegaranti i kronor" class="text-right-sm-left">{{ c.lgBeloppTotal_cache | localizednumber }} kr</td>
                  <td data-name="Fordran" title="Fordran i kronor" class="text-right-sm-left">{{ c.fordranBeloppTotal_cache | localizednumber }} kr</td>
                  <td data-name="Dokument" class="beslut-file">
                    <file-link *ngIf="c.beslutTyp.typ!=='b2'" [file]="c.fil"></file-link>
                    <individual-b2-link *ngIf="c.beslutTyp.typ==='b2'" [beslut]="c"></individual-b2-link>
                  </td>
                  <td data-name="Signatur" class="text-center-sm-left">
                    <signature-icon [signature]="c.beslutTyp.typ==='b2' ? c.huvudB2?.fil?.signatur : c.fil?.signatur" *ngIf="((c.beslutTyp.typ==='b2' ? c.huvudB2?.fil?.filtillagg : c.fil?.filtillagg) | lowercase)==='.pdf'"></signature-icon>
                  </td>
                  <td data-name="Vald" title="Vald" class="text-center-sm-left" *ngIf="role==='adv' && ((c.beslutTyp.typ==='b2' ? c.huvudB2?.fil?.filtillagg : c.fil?.filtillagg) | lowercase)==='.pdf'">
                    <div class="form-group mb-0" *ngIf="c.beslutTyp.typ!=='b2'">
                      <div class="checkbox">
                        <label class="mb-0">
                          <input type="checkbox" class="form-check-input" [checked]="!!c.isSelected || c.fil?.signatur" [disabled]="c.fil?.signatur" (change)="c.isSelected = !c.isSelected">
                          <span class="cr"><fa-icon [icon]="['fas', 'check']" transform="grow-3" class="cr-icon"></fa-icon></span>
                        </label>
                      </div>
                    </div>
                    <div class="form-group mb-0" *ngIf="c.beslutTyp.typ==='b2' && c.huvudB2?.fil?.signatur">
                      <div class="checkbox">
                        <label class="mb-0">
                          <input type="checkbox" class="form-check-input" checked disabled>
                          <span class="cr"><fa-icon [icon]="['fas', 'check']" transform="grow-3" class="cr-icon"></fa-icon></span>
                        </label>
                      </div>
                    </div>
                  </td>
                  <td *ngIf="role==='adv' && ((c.beslutTyp.typ==='b2' ? c.huvudB2?.fil?.filtillagg : c.fil?.filtillagg) | lowercase)!=='.pdf'"></td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th data-name="Antal beslut" title="Antal beslut" colspan="3">{{ anstallning.lonegarantiBeslut.length | localizednumber }} st</th>
                  <th data-name="Total lönegaranti" title="Total lönegaranti i kronor" class="text-right-sm-left">{{ getSum(anstallning.lonegarantiBeslut, 'lgBeloppTotal_cache') | localizednumber }} kr</th>
                  <th data-name="Total fordran" title="Total fordran i kronor" class="text-right-sm-left">{{ getSum(anstallning.lonegarantiBeslut, 'fordranBeloppTotal_cache') | localizednumber }} kr</th>
                  <th></th>
                  <th></th>
                  <th *ngIf="role==='adv'"></th>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="container-fluid" *ngIf="role==='adv' && harBeslutKvarAttSignera">
            <div class="row">
              <sign [files]="selectedFiles" (onSuccess)="reloadAnstallning()" class="d-flex w-100" btnClass="btn-garanti btn-blue ml-auto"></sign>
            </div>
          </div>
          <p class="text-muted" *ngIf="!anstallning.lonegarantiBeslut.length">Inga beslut</p>
          <hr />
          <p class="h5">Arbetstagarens bilagor</p>
          <div class="table-responsive" *ngIf="bilagors.length">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" style="width:120px">Datum</th>
                  <th scope="col">Beskrivning</th>
                  <th scope="col" style="width:140px">Dokument</th>
                  <th scope="col" class="text-center-sm-left" style="width:160px">Signatur</th>
                  <th scope="col" class="text-center-sm-left" style="width:45px" *ngIf="role==='adv'">Vald</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let d of bilagors | orderBy: ['-datumSparat', 'beskrivning']">
                  <td data-name="Datum" title="Datum">{{ d.datumSparat | localizeddate:'shortDate' }}</td>
                  <td data-name="Beskrivning" title="Beskrivning">{{ d.beskrivning }}</td>
                  <td data-name="Dokument" title="Dokument" class="beslut-file"><file-link [file]="d"></file-link></td>
                  <td data-name="Signatur" class="text-center-sm-left">
                    <signature-icon [signature]="d.signatur" *ngIf="(d.filtillagg | lowercase)==='.pdf'"></signature-icon>
                  </td>
                  <td data-name="Vald" title="Vald" class="text-center-sm-left" *ngIf="role==='adv' && (d.filtillagg | lowercase)==='.pdf'">
                    <div class="form-group mb-0">
                      <div class="checkbox">
                        <label class="mb-0">
                          <input type="checkbox" class="form-check-input" [checked]="!!d.isSelected || d.signatur" [disabled]="d.signatur" (change)="d.isSelected = !d.isSelected">
                          <span class="cr"><fa-icon [icon]="['fas', 'check']" transform="grow-3" class="cr-icon"></fa-icon></span>
                        </label>
                      </div>
                    </div>
                  </td>
                  <td *ngIf="role==='adv' && (d.filtillagg | lowercase)!=='.pdf'"></td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="text-muted" *ngIf="!bilagors.length">Inga bilagor</p>
          <div class="container-fluid" *ngIf="role==='adv' && harBilagorKvarAttSignera">
            <div class="row">
              <sign [files]="selectedFiles" (onSuccess)="reloadAnstallning()" class="d-flex w-100" btnClass="btn-garanti btn-blue ml-auto"></sign>
            </div>
          </div>
          <a [routerLink]="['/mina-arenden', anstallning.arende.id]" class="btn-garanti btn-blue mt-3"><fa-icon [icon]="['fas', 'arrow-left']" class="mr-2"></fa-icon>Tillbaka till ärendet</a>
        </div>
      </div>
    </div>
  </div>
</div>
